import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const aromaMemoBadgeDefaultVariants = {
  "size": "small",
  "colorTheme": "neutral"
}
const aromaMemoBadgeCompoundVariants = [
  {
    "size": "small",
    "colorTheme": "pink",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.pink.base-bolder",
          "borderColor": "background.decorative.pink.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "small",
    "colorTheme": "purple",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.purple.base-bolder",
          "borderColor": "background.decorative.purple.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "small",
    "colorTheme": "blue",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.blue.base-bolder",
          "borderColor": "background.decorative.blue.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "small",
    "colorTheme": "green",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.green.base-bolder",
          "borderColor": "background.decorative.green.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "small",
    "colorTheme": "yellow",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.yellow.base-bolder",
          "borderColor": "background.decorative.yellow.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "small",
    "colorTheme": "orange",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.orange.base-bolder",
          "borderColor": "background.decorative.orange.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "small",
    "colorTheme": "red",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.red.base-bolder",
          "borderColor": "background.decorative.red.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "small",
    "colorTheme": "neutral",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.neutral.base-bolder",
          "borderColor": "background.decorative.neutral.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "medium",
    "colorTheme": "pink",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.pink.base-bolder",
          "borderColor": "background.decorative.pink.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "medium",
    "colorTheme": "purple",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.purple.base-bolder",
          "borderColor": "background.decorative.purple.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "medium",
    "colorTheme": "blue",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.blue.base-bolder",
          "borderColor": "background.decorative.blue.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "medium",
    "colorTheme": "green",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.green.base-bolder",
          "borderColor": "background.decorative.green.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "medium",
    "colorTheme": "yellow",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.yellow.base-bolder",
          "borderColor": "background.decorative.yellow.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "medium",
    "colorTheme": "orange",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.orange.base-bolder",
          "borderColor": "background.decorative.orange.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "medium",
    "colorTheme": "red",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.red.base-bolder",
          "borderColor": "background.decorative.red.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  },
  {
    "size": "medium",
    "colorTheme": "neutral",
    "css": {
      "wrap": {
        "_active": {
          "backgroundColor": "background.decorative.neutral.base-bolder",
          "borderColor": "background.decorative.neutral.base-bolder",
          "color": "content.neutral.reverse.bold"
        }
      }
    }
  }
]

const aromaMemoBadgeSlotNames = [
  [
    "wrap",
    "aroma-memo-badge__wrap"
  ],
  [
    "description",
    "aroma-memo-badge__description"
  ],
  [
    "menuTrigger",
    "aroma-memo-badge__menuTrigger"
  ],
  [
    "datesWrap",
    "aroma-memo-badge__datesWrap"
  ],
  [
    "title",
    "aroma-memo-badge__title"
  ]
]
const aromaMemoBadgeSlotFns = /* @__PURE__ */ aromaMemoBadgeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, aromaMemoBadgeDefaultVariants, getSlotCompoundVariant(aromaMemoBadgeCompoundVariants, slotName))])

const aromaMemoBadgeFn = memo((props = {}) => {
  return Object.fromEntries(aromaMemoBadgeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const aromaMemoBadgeVariantKeys = [
  "size",
  "colorTheme",
  "warning",
  "disabled"
]
const getVariantProps = (variants) => ({ ...aromaMemoBadgeDefaultVariants, ...compact(variants) })

export const aromaMemoBadge = /* @__PURE__ */ Object.assign(aromaMemoBadgeFn, {
  __recipe__: false,
  __name__: 'aromaMemoBadge',
  raw: (props) => props,
  variantKeys: aromaMemoBadgeVariantKeys,
  variantMap: {
  "size": [
    "small",
    "medium",
    "large"
  ],
  "colorTheme": [
    "pink",
    "purple",
    "blue",
    "green",
    "yellow",
    "orange",
    "red",
    "neutral"
  ],
  "warning": [
    "true",
    "false"
  ],
  "disabled": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, aromaMemoBadgeVariantKeys)
  },
  getVariantProps
})